<template>
  <div class="chart-wrapper p-1">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';

export default {
  name: 'ChartBarEvents',
  props: {
    labels: {
      type: Array,
      required: true,
    },
    reviews: {
      type: Array,
      required: true,
    },
    logins: {
      type: Array,
      required: true,
    },
    productOrders: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    Chart.register(...registerables);
    // eslint-disable-next-line no-new
    new Chart(
      this.$refs.chart.getContext('2d'),
      {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [{
            label: 'Logins',
            data: this.logins,
            backgroundColor: [
              '#649CD9',
            ],
            borderColor: [
              '#649CD9',
            ],
            borderWidth: 2,
          },
          {
            label: 'Reviews',
            data: this.reviews,
            backgroundColor: [
              '#F2AC42',
            ],
            borderColor: [
              '#F2AC42',
            ],
            borderWidth: 2,
          },
          {
            label: 'Product Orders',
            data: this.productOrders,
            backgroundColor: [
              '#E16071',
            ],
            borderColor: [
              '#E16071',
            ],
            borderWidth: 2,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
          },
        },
      },
    );
  },
};
</script>

<style scoped>
.chart-wrapper {
  height: 400px;
}
</style>
